import React from 'react'
import { useTranslation } from 'react-i18next'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'
import { assertExists } from '~/utils'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { useMainQueryStrategyMemo } from '../hooks/useMainQuery'
import { useStrategyMemoId } from '../hooks/useStrategyMemoId'

export const StrategyMemoShareButton = () => {
  const { t } = useTranslation()
  const brandAccountId = useBrandAccountId()
  const strategyMemoId = useStrategyMemoId()
  const copyToClipboard = useCopyToClipboard()
  const strategyMemo = useMainQueryStrategyMemo()
  assertExists(strategyMemo, t('assertion_failed'))
  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    const url = `${window.location.origin}${compile('strategyMemoEdit', {
      brandAccountId,
      strategyMemoId,
    })}`
    copyToClipboard(url, {
      notificationText: t('strategymemo_title_url_copied_to_clipboard', {
        title: strategyMemo.title,
      }),
    })
  }, [brandAccountId, copyToClipboard, strategyMemo, strategyMemoId, t])

  return <IconButton fillMode="outline" icon="share" onClick={handleClick} />
}
